
import { mapGetters, mapActions, mapState } from 'vuex';
import propsForMixin from '../../mixins/props-for';
import Message from './Message.vue';

export default {
  components: { Message },
  mixins: [propsForMixin],
  props: {
    media: { type: Object, default: () => ({}) },
    node: { type: Object, default: () => ({}) },
    headline: { type: String, default: '' },
    description: { type: String, default: '' },
    autoPlay: { type: Boolean, default: false },
    stackIndex: { type: Number, default: 0 },
    showSkip: { type: Boolean, default: false },
    conversation: { type: String, default: '' },
  },

  data() {
    return {
      playing: false,
      waiting: false,
      progress: 0,
      max: 0,
      currentTime: 0,
      error: null,
    };
  },

  computed: {
    ...mapGetters('chatbotStore', ['ampConfig', 'currentConversationId', 'currentStack']),
    ...mapState('playerStore', ['mediaError', 'playingUID']),

    audioElement() {
      return this.$refs.audio;
    },

    isCurrentNode() {
      return this.conversation === this.currentConversationId && this.currentStack.length - 1 === this.stackIndex;
    },

    playIcon() {
      return this.playing ? 'pause' : 'play';
    },
  },

  watch: {
    media: {
      deep: true,
      async handler(newMedia, oldMedia) {
        if (newMedia.url && newMedia.url !== oldMedia?.url) {
          this.pause();
          this.audioPause();
        }
      },
    },

    playingUID(uid) {
      if (uid && uid !== this._uid && this.playing) {
        this.pause();
      }
    }
  },

  methods: {
    ...mapActions('playerStore', ['setPlayingUID', 'setMediaEnded', 'setMediaError']),

    async play() {
      if (!this.audioElement) return;

      await this.audioElement.play();
    },

    pause() {
      if (!this.audioElement) return;

      this.audioElement.pause();
    },

    handlePlayIconPress() {
      if (!this.media?.url) return;

      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    },

    handleSkipPress() {
      this.pause();
      this.setMediaEnded({ finished: true, saveToStorage: false });
    },

    audioMetaData() {
      this.max = Math.ceil(this.audioElement.duration);
    },

    audioPlay() {
      this.playing = true;
      this.setPlayingUID(this._uid);
    },

    audioPlaying() {
      this.waiting = false;
    },

    audioWaiting() {
      this.waiting = true;
    },

    audioPause() {
      this.playing = false;

      if (this.playingUID && this.playingUID === this._uid) {
        this.setPlayingUID(null);
      }
    },

    audioEnded() {
      this.pause();
      this.currentTime = this.max;

      if (this.isCurrentNode) {
        this.setMediaEnded({ finished: true, saveToStorage: true });
      }
    },

    audioTimeupdate() {
      this.currentTime = Math.min(this.audioElement.currentTime, Math.ceil(this.audioElement.currentTime));
    },

    getDurationInSeconds(duration) {
      if (duration === 0) return '0:00';

      const mins = Math.floor(duration / 60);
      const seconds = Math.round(duration % 60);

      return `${mins}:${seconds < 10 ? `0${seconds}` : seconds}`;
    },
  },
};
